import images.ResImages
import strings.ResStrings

public object Res {
  public val string: ResStrings = ResStrings

  public val image: ResImages = ResImages
}
